import {Component} from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {addNotification, NOTIFICATION_TYPE} from 'modules/notifications';
import {removeWebSocketConexion} from 'modules/websockets';
import {checkWebSocketTimeoutExpired} from './utils/utils';
import {TIME} from 'util/constants';
import endpoints from 'config/endpoints';

/** This component will fetch the responses from websockets channel and it will dispatch alerts showing information */
class WebsocketsContainer extends Component {

    static propTypes = {
        webSockets: PropTypes.array, // The list with the websockets actions
        userId:     PropTypes.number, // The user id to make the request
        token:      PropTypes.string // The token to auth the conexion
    };

    componentWillMount() {
        const {dispatch, webSockets, intl: {formatMessage}, userId, token} = this.props;
        const URL = `${endpoints.webSocketConexion.endpoint}${userId}/?access_token=${token}`;
        const socket = new WebSocket(URL);

        this.setState({
            socket
        });

        this.handleSend = this.handleSend.bind(this);
        const currentDay = new Date().getTime();

        webSockets.forEach(webSocket => {
            if (checkWebSocketTimeoutExpired(webSocket.creationTime * TIME.MILISECONDS, currentDay)) {
                dispatch(removeWebSocketConexion(webSocket));
                dispatch(
                    addNotification(
                        formatMessage({id: webSocket.section}),
                        formatMessage({id: 'EXPORT_ERROR'}),
                        NOTIFICATION_TYPE.ERROR));
            }

        });

        socket.onopen = () => {
            // Escribir aquí lo que se quiere que se haga al abrir la conexión

        };

        socket.onclose = e => {
            // Escribir aquí lo que se quiere que se haga al cerrarse la conexión
        };

        socket.onmessage = response => {
            this.handleOnMessage(response);
        };

        socket.onerror = e => {
            // Escribir aquí lo que se quiere que se haga al haber un error
        };
    }

    handleOnMessage(response) {
        const {dispatch, intl: {formatMessage}, webSockets} = this.props;

        if (response) {
            const {message} = JSON.parse(response.data);

            message.forEach(item => {
                if (item.type === 'SUCCESS') {
                    const webSocket = webSockets.find(element => element.id === item.id);
                    const {data} = item;

                    if (webSocket) {

                        data.forEach(el => {
                            dispatch(addNotification(
                                formatMessage({id: webSocket.section}),
                                formatMessage({id: item.type}),
                                NOTIFICATION_TYPE.SUCCESS,
                                undefined, undefined, undefined,
                                {url: el.url, filename: el.filename}
                            ));
                            dispatch(removeWebSocketConexion(item.id));
                            this.handleSend(`{"id": "${item.id}"}`);
                        });
                    }
                } else {
                    dispatch(addNotification(
                        formatMessage({id: 'title.error'}),
                        formatMessage({id: 'ERROR_WEBSOCKET'}),
                        NOTIFICATION_TYPE.ERROR));
                    this.handleSend(`{"id": "${item.id}"}`);
                }
            });
        }
    }

    handleSend(message) {
        const {socket} = this.state;

        socket.send(message);

    }


    render() {
        return null;
    }
}

const mapStateToProps = state => {
    const {webSockets} = state.websockets;
    const userId = state.auth.user.id;
    const token = state.api.accessToken;

    return {
        webSockets,
        userId,
        token
    };
};

export default injectIntl(connect(mapStateToProps)(WebsocketsContainer));



// WEBPACK FOOTER //
// ./src/containers/websockets/WebsocketsContainer.jsx